module.exports = function(angular, app) {
  var moment = require('./moment-global.js')
    , relativeinterval = require('../../deep-query-api/lib/relativeinterval');

  relativeinterval.RelativeInterval.prototype.toMoments = function(refdate) {
    var dates = this.toDates(refdate);
    return [moment(dates[0]), moment(dates[1])];
  };

  app
    .factory('RelativeInterval', function() { return relativeinterval.RelativeInterval; })
    .factory('RelativeDate', function() { return relativeinterval.RelativeDate; })
    .factory('Duration', function() { return relativeinterval.Duration; });
};

/*

//------------------//
// RelativeInterval //
//------------------//

var relativeinterval = new RelativeInterval("2012-01-01T00:00:00/2012-01-01T23:59:59.999")
var relativeinterval = new RelativeInterval("2012-01-01T00:00:00/P2DT12H")
var relativeinterval = new RelativeInterval("####-##-##T##:00:00/PT1H")
var relativeinterval = new RelativeInterval("PT1H/####-##-##T##:23:59:59.999")
var relativeinterval = new RelativeInterval("P1D/2012-01-01T23:59:59.999")
var relativeinterval = new RelativeInterval("today");
var relativeinterval = new RelativeInterval("this_week");
var relativeinterval = new RelativeInterval("this_month");
var relativeinterval = new RelativeInterval("yesterday");
var relativeinterval = new RelativeInterval("last_week");
var relativeinterval = new RelativeInterval("last_month");
var relativeinterval = new RelativeInterval("last_hour");
var relativeinterval = new RelativeInterval("last_minute");
var relativeinterval = new RelativeInterval([moment().subtract(2, 'days'), moment()]);
var relativeinterval = new RelativeInterval(relativeinterval);
var relativeinterval = new RelativeInterval(relativeinterval.toString());

relativeinterval.isAbsolute() -> boolean
relativeinterval.isRelative() -> boolean

// in the following methods absolute interval is calculated according to given refdate
// the refdate argument can be ommited - new Date() is used in such instance
// the refdate argument should be a reference date or a timestamp as a number
relativeinterval.hasFutureStart(refdate) -> boolean
relativeinterval.hasFutureEnd(refdate)   -> boolean
relativeinterval.toDates(refdate)        -> [Date, Date]
relativeinterval.startDate(refdate)      -> Date
relativeinterval.endDate(refdate)        -> Date
relativeinterval.toISOString(refdate)    -> string
relativeinterval.toTimestamps(refdate)   -> [number, number]
relativeinterval.toMoments(refdate)      -> [moment, moment]
relativeinterval.toMilliseconds(refdate) -> number
relativeinterval.toSeconds(refdate)      -> number
relativeinterval.toISODuration(refdate)  -> string

// serialize duration
// set forceISO to true to normalize string to iso (not a token such as "today")
relativeinterval.toString(forceISO) -> String

//----------//
// Duration //
//----------//

var duration = new Duration("P1Y3M7DT12H4M12.5S");
var duration = new Duration(86400000); // equivalence to "P1D"
var duration = new Duration(duration);
var duration = new Duration(duration.toString());

// modifies date in-place adding a duration value to it
duration.addToDate(date)        -> date

// modifies date in-place subtracting a duration value from it
duration.subtractFromDate(date) -> date

// serialize duration
duration.toString() -> string

//--------------//
// RelativeDate //
//--------------//

var relativedate = new RelativeDate("2012-01-01T00:00:00.000+0200")
var relativedate = new RelativeDate("####-##-##T##:00:00Z")
var relativedate = new RelativeDate(new Date())
var relativedate = new RelativeDate(Date.now())
var relativedate = new RelativeDate(relativedate)
var relativedate = new RelativeDate(relativedate.toString())

// read-only check if date is relative
relativedate.relative -> boolean

// return instance of absolute Date according to given refdate
// the refdate argument can be ommited - new Date() is used in such instance
// the refdate argument should be a reference date or a timestamp as a number
relativedate.toDate(refdate) -> Date

// serialize relative date
// set forceISO to true to have normalized iso string (e.g. with time part)
relativedate.toString(forceISO) -> string

*/
